<template>
  <div class="dwp-p-6 dwp-space-y-8">
    <div class="dwp-flex dwp-items-center dwp-justify-center">
      <div
        class="sm:dwp-text-2xl dwp-text-xl dwp-leading-none dwp-text-gray-700 dwp-font-medium"
      >What do you want to import?</div>
    </div>

    <div class="dwp-flex dwp-items-stretch dwp-justify-center dwp-space-x-8">
      <SelectBox @click.native="$emit('update:value', 'library')" data-cy="official-library">
        <BookOpenIcon
          class="dwp-text-gray-400 dwp-pb-2 dwp-h-8 group-hover:dwp-text-primary-700 dwp-transition-colors dwp-duration-200"
        />
        <h3
          class="dwp-leading-none dwp-font-bold group-hover:dwp-text-primary-700 dwp-text-gray-700 dwp-transition-colors dwp-duration-200"
        >Official Library</h3>
        <p class="dwp-text-sm dwp-text-gray-500">Load checklists from the official cloud library.</p>
      </SelectBox>

      <SelectBox @click.native="$emit('update:value', 'saved')" data-cy="saved-library">
        <DownloadCloudIcon
          class="dwp-text-gray-400 dwp-pb-2 dwp-h-8 group-hover:dwp-text-primary-700 dwp-transition-colors dwp-duration-200"
        />
        <h3
          class="dwp-leading-none dwp-font-bold group-hover:dwp-text-primary-700 dwp-text-gray-700 dwp-transition-colors dwp-duration-200"
        >My Saved Lists</h3>
        <p class="dwp-text-sm dwp-text-gray-500">Load checklists you've saved to the cloud.</p>
      </SelectBox>
    </div>
  </div>
</template>

<script>
import { DownloadCloudIcon, BookOpenIcon } from "vue-feather-icons";
import SelectBox from "@/components/templates/SelectBoxTemplate.vue";
export default {
  components: {
    DownloadCloudIcon,
    BookOpenIcon,
    SelectBox,
  },
  props: {
    value: String | Boolean,
  },
};
</script>